module.exports = __webpack_public_path__ + "static/icon-dashboard-21ca689f54651d7a7e51983339ab8d22.svg";